import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import withWidth from "@material-ui/core/withWidth";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import { withStyles } from "@material-ui/core/styles";

import { changeCourses, changePolls, changeSessions, changeSelRole } from "../redux";

const styles = (theme) => ({});

function SelectRole(props) {
    return (
        <FormControl style={{ width:102 }}>
            <InputLabel 
              id="view-select-label"
              style={{
                fontSize: 12,
                marginTop: 2,
              }}
            >
              View
            </InputLabel>
            <Select
                labelId="view-select-label"
                id="view-select"
                value={props.selRole}
                label="View"
                style={{
                  fontSize: 13,
                  height:40,
                }}
                onChange={(event) => {
                    props.changeSelRole(event.target.value);
                    props.history.push("/loading");
                }}
            >
                {props.account.accountType === "ta" ? null : <MenuItem value={"instructor"}>Instructor</MenuItem>}
                <MenuItem value={"ta"}>TA</MenuItem>
                <MenuItem value={"student"}>Student</MenuItem>
            </Select>
        </FormControl>
    )
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    changePolls: (data) => dispatch(changePolls(data)),
    changeSessions: (data) => dispatch(changeSessions(data)),
    changeCourses: (data) => dispatch(changeCourses(data)),
    changeSelRole: (data) => dispatch(changeSelRole(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(SelectRole))
  )
);
